











import { Component, Vue } from 'vue-property-decorator';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { updateToken } from '../auth2';
import router from '../router';
import { updateAuthorizationToken } from '../axiosInstance';

const CLIENT_ID = '4kddq1drlnsik533qnbqemgec7'; 
const USER_POOL_ID = 'us-west-2_Pp6aN1Yf2';

@Component
export default class Login extends Vue {
    username = '';
    password = '';

    async submit () {
        console.log('submit')
        if (!this.username || !this.password) {
            return;
        }

        // https://github.com/aws-amplify/amplify-js/tree/master/packages/amazon-cognito-identity-js
        const authenticationData = {
            Username: this.username,
            Password: this.password,
        };
        const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
            authenticationData
        );
        const poolData = {
            UserPoolId: USER_POOL_ID,
            ClientId: CLIENT_ID,
        };
        const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        const userData = {
            Username: this.username,
            Pool: userPool,
        };
        const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: (result) => {
                // const accessToken = result.getAccessToken().getJwtToken();
                const idToken = result.getIdToken().getJwtToken();
                console.log('idToken', idToken);
                updateToken(idToken);
                updateAuthorizationToken(idToken);

                const redirectTo: string = this.$route.query.redirect ? this.$route.query.redirect.toString() : '/';
                router.replace(redirectTo)

                //POTENTIAL: Region needs to be set if not already set previously elsewhere.
                // AWS.config.region = AWS_REGION;

                // AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                //     IdentityPoolId: '...', // your identity pool id here
                //     Logins: {
                //         // Change the key below according to the specific region your user pool is in.
                //         'cognito-idp.<region>.amazonaws.com/<YOUR_USER_POOL_ID>': result
                //             .getIdToken()
                //             .getJwtToken(),
                //     },
                // });

                //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
                // AWS.config.credentials.refresh(error => {
                //     if (error) {
                //         console.error(error);
                //     } else {
                //         // Instantiate aws sdk service objects now that the credentials have been updated.
                //         // example: var s3 = new AWS.S3();
                //         console.log('Successfully logged!');
                //     }
                // });
            },

            onFailure: function(err) {
                console.error(err.message || JSON.stringify(err));
            },
        });
    }
}
